var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.courseTreatmentStr)?_c('span',{staticClass:"course-treatment"},[_vm._v(" "+_vm._s(_vm.courseTreatmentStr)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }